module.exports = __webpack_public_path__ + "files/ffe292cf22f42eb2d5d54fcc1cc73a98.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-72x72.png
// module id = 1244
// module chunks = 76